import { FieldProps, Field as HeadlessField } from "@headlessui/react";

export default function Field({
    children,
    className = "",
    ...rest
}: FieldProps) {
    return (
        <HeadlessField
            {...rest}
            className={`flex flex-col gap-y-1 ${className}`}
        >
            {children}
        </HeadlessField>
    );
}
